import React from "react";
import { ArrowRight, Home, Search } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import Seo from "./Seo";

/* Friendly 404 page. Returns prerendered HTML at /404.html and is also
   the catch-all route inside the SPA. Suggests likely destinations rather
   than just shrugging at the visitor. */
const NotFound = () => (
  <div className="bs-app">
    <Seo
      title="Page not found - british-sign.co.uk"
      description="We couldn’t find the page you were looking for. Try the homepage, our free BSL dictionary, or get in touch."
      path="/404"
      noindex
    />
    <Header />
    <main className="bs-legal">
      <section className="bs-legal__hero">
        <div className="bs-container">
          <span className="bs-eyebrow">404</span>
          <h1 className="bs-legal__h1" data-testid="notfound-h1">
            We can’t find that page.
          </h1>
          <p className="bs-legal__updated">
            The link may be broken, or the page may have moved. Try one of the
            options below.
          </p>
        </div>
      </section>

      <section className="bs-legal__section">
        <div
          className="bs-container"
          style={{
            display: "grid",
            gap: "16px",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            maxWidth: 880,
          }}
        >
          <a
            href="/"
            data-testid="notfound-home-link"
            style={{
              display: "block",
              border: "1px solid #e3e8ee",
              borderRadius: "14px",
              padding: "20px 22px",
              background: "#fff",
              textDecoration: "none",
              color: "#0B1B2E",
            }}
          >
            <Home size={22} />
            <div style={{ fontWeight: 700, marginTop: 10 }}>
              Back to the homepage
            </div>
            <div style={{ color: "#4b5868", marginTop: 4, fontSize: "0.95rem" }}>
              See what british-sign.co.uk has to offer.
            </div>
          </a>

          <a
            href="/british-sign-language/dictionary/"
            data-testid="notfound-dictionary-link"
            style={{
              display: "block",
              border: "1px solid #e3e8ee",
              borderRadius: "14px",
              padding: "20px 22px",
              background: "#fff",
              textDecoration: "none",
              color: "#0B1B2E",
            }}
          >
            <Search size={22} />
            <div style={{ fontWeight: 700, marginTop: 10 }}>
              Search the BSL dictionary
            </div>
            <div style={{ color: "#4b5868", marginTop: 4, fontSize: "0.95rem" }}>
              Look up a sign across thousands of free videos.
            </div>
          </a>

          <a
            href="/enrol"
            data-testid="notfound-enrol-link"
            style={{
              display: "block",
              border: "1px solid #e3e8ee",
              borderRadius: "14px",
              padding: "20px 22px",
              background: "#0B1B2E",
              textDecoration: "none",
              color: "#fff",
            }}
          >
            <ArrowRight size={22} />
            <div style={{ fontWeight: 700, marginTop: 10 }}>
              Enrol on the course
            </div>
            <div style={{ color: "#cdd6e0", marginTop: 4, fontSize: "0.95rem" }}>
              CPD-certified, pay what you can from £5.
            </div>
          </a>

          <a
            href="/contact"
            data-testid="notfound-contact-link"
            style={{
              display: "block",
              border: "1px solid #e3e8ee",
              borderRadius: "14px",
              padding: "20px 22px",
              background: "#fff",
              textDecoration: "none",
              color: "#0B1B2E",
            }}
          >
            <ArrowRight size={22} />
            <div style={{ fontWeight: 700, marginTop: 10 }}>Get in touch</div>
            <div style={{ color: "#4b5868", marginTop: 4, fontSize: "0.95rem" }}>
              Tell us which link sent you here so we can fix it.
            </div>
          </a>
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

export default NotFound;
